import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import flattenChildren from 'react-keyed-flatten-children'
import { isElement } from 'react-is'
import type { ReactNode } from 'react'
import { useMfId } from '../components/mf-provider'
export { toast } from 'sonner'
export { REGEXP_ONLY_DIGITS_AND_CHARS } from 'input-otp'

// Phone validation and country data moved to ./phone: their libphonenumber
// weight must not ride along with cn/toast, which every component imports.

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// maybe document.documentElement??
export function useMfRootElement(or: Element): Element
export function useMfRootElement(): Element | undefined
export function useMfRootElement(or?: Element) {
  const mfId = useMfId()
  if (!mfId) return or

  const remoteEl = document.querySelector(`#${mfId}`)
  return remoteEl?.shadowRoot?.querySelector('#mf-root') ?? or
}

export function useMfShadowRoot() {
  const mfId = useMfId()
  if (!mfId) return undefined

  const remoteEl = document.querySelector(`#${mfId}`)
  return remoteEl?.shadowRoot ?? undefined
}

// export function useMfRootElement(or: Element): Element
// export function useMfRootElement(): Element | undefined
// export function useMfRootElement(or?: Element) {
//   const remoteEl = document.querySelector('#remote-mf')
//   return remoteEl?.shadowRoot?.querySelector('#mf-root') ?? or
// }

// export function getMfShadowRoot() {
//   const remoteEl = document.querySelector('#remote-mf')
//   return remoteEl?.shadowRoot ?? undefined
// }

export function extractTextFromChildren(children: ReactNode): string {
  const flatChildren = flattenChildren(children as Parameters<typeof flattenChildren>[0])

  let text = ''

  // Process each flattened child
  flatChildren.forEach((child) => {
    // If child is a string or number, add it to the text
    if (typeof child === 'string' || typeof child === 'number') {
      text += child
    }
    // If child is a React element with children, recursively extract text
    // @ts-ignore
    else if (isElement(child) && child.props.children) {
      // @ts-ignore
      text += extractTextFromChildren(child.props.children)
    }
  })

  return text.trim()
}
